<template>
  <div>
    <v-card v-if="true === healthCheck" flat>
      <v-card-title class="grey lighten-5">
        Router
      </v-card-title>
      <v-row v-if="loadingHealthCheck" align="center" justify="center" no-gutters class="my-6">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
      <v-card-text v-else-if="false === healthCheck">
        <v-row justify="center" class="text-center">
          <div class="py-12">
            <v-icon color="grey lighten-2" size="100px">mdi-router-wireless-off</v-icon>
            <h1 class="headline">No Router integration</h1>
          </div>
        </v-row>
      </v-card-text>
      <template v-else-if="true === healthCheck">
        <v-card-text>
          <SiteVpnMikrotikInterfaces :site-vpn="siteVpn" @reload="getRouterosHealthCheck" />
        </v-card-text>
        <SiteVpnMikrotikGroups :site-vpn="siteVpn" />
      </template>
    </v-card>
  </div>
</template>
<script>
import SiteVpnMikrotikInterfaces from '@/components/Vpn/MikrotikInterfaces.vue'
import SiteVpnMikrotikGroups from '@/components/Vpn/MikrotikGroups.vue'
import fetch from '@/utils/fetch'
export default {
  name: 'SiteVpnMikrotik',
  components: { SiteVpnMikrotikGroups, SiteVpnMikrotikInterfaces },
  props: {
    siteVpn: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingHealthCheck: null,
      healthCheck: null,
      error: null
    }
  },
  mounted() {
    this.getRouterosHealthCheck()
  },
  methods: {
    getRouterosHealthCheck() {
      this.loadingHealthCheck = true
      fetch(this.siteVpn['@id'] + '/routeros/health_check')
        .then(response => response.json())
        .then(data => {
          this.healthCheck = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingHealthCheck = false
        })
    }
  }
}
</script>
